import type { DeviceAccessorySlot, DeviceShelfLifeInfo, DueAccessory } from 'store/types'

const BADGES: Record<string, { className: string; label: string }> = {
  ASSIGNED: { className: 'badge-success', label: 'Assigned' },
  EXPIRED: { className: 'badge-warning', label: 'Expired' },
  NOT_ASSIGNED: { className: 'badge-danger', label: 'Not assigned' },
}

interface IProps {
  shelfLife?: DeviceShelfLifeInfo | null
}

// TES-3191: where a tracked device stands on its accessories; one missing outranks one worn out.
export const AccessoriesStateCell = ({ shelfLife }: IProps) => {
  const badge = shelfLife?.accessoriesState ? BADGES[String(shelfLife.accessoriesState)] : undefined

  if (!shelfLife || !badge) return <>—</>

  const missing = shelfLife.missingAccessories.map((slot: DeviceAccessorySlot) => slot.label)
  const due = shelfLife.accessoriesDue.map((item: DueAccessory) => item.label)
  const title = missing.length
    ? `Not assigned: ${missing.join(', ')}`
    : due.length
      ? `Due for replacement: ${due.join(', ')}`
      : undefined

  return (
    <span className={`badge ${badge.className}`} title={title} aria-label={title}>
      {badge.label}
    </span>
  )
}
